var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowScrolldown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 0 40 23",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square",
    transform: "matrix(0 -1 1 0 7.5 32.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.5-2.5-12.8786797 12.8786797c-1.1715728 1.1715728-1.1715728 3.0710678 0 4.2426406l12.8786797 12.8786797",
    stroke: "#fff",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5-2.5-12.8786797 12.8786797c-1.1715728 1.1715728-1.1715728 3.0710678 0 4.2426406l12.8786797 12.8786797",
    stroke: "#000",
    strokeWidth: 4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowScrolldown);
export default __webpack_public_path__ + "static/media/arrow_scrolldown.64fec5e3e7c31309253ce1e7f5c13691.svg";
export { ForwardRef as ReactComponent };